import { lazyWithPreload } from '../../navigation';

export const OpenAPISpecScreen = lazyWithPreload(() =>
    import('./OpenAPISpecScreen').then((m) => ({ default: m.OpenAPISpecScreen }))
);
export const OpenAPISpecsHomeScreen = lazyWithPreload(() =>
    import('./OpenAPISpecsHomeScreen').then((m) => ({ default: m.OpenAPISpecsHomeScreen }))
);
